<template>
  <div class="SCTransaction">
    <section-header heading="2" ja="「資金決済に関する法律」に基づく表示"/>
    <div class="terms-text">
      <p>1.前払支払手段の名称</p>
      <p>チケット</p>
    </div>
    <div class="terms-text">
      <p>2.前払式支払手段発行者の名称、苦情または相談窓口の所在地、連絡先</p>
      <p>
        名称：株式会社セガ<br>
        住所：〒141-0033東京都品川区西品川一丁目1番1号 住友不動産大崎ガーデンタワー<br>
        電話：0570-000-353<br>
        ﾒｰﾙｱﾄﾞﾚｽ: segaonlinesupport@sega.com
      </p>
    </div>
    <div class="terms-text">
      <p>3.前払式支払手段の支払い可能金額等</p>
      <p>チケットを保有できる上限の定めはありません。但し「プリクラON」利用規約第８条第１項に基づき上限を設定する場合があり、その場合にはその上限が適用されます。</p>
    </div>
    <div class="terms-text">
      <p>4.前払式支払手段の有効期間・有効期限</p>
      <p>有効期間・有効期限の定めはありません。但し「プリクラON」利用規約第８条第５項に該当する場合には失効します。</p>
    </div>
    <div class="terms-text">
      <p>5.前払式支払手段を使用する事ができる範囲</p>
      <p>本サービス「プリクラON」内においてのみ使用することができます。</p>
    </div>
    <div class="terms-text">
      <p>6.前払式支払手段の利用上の必要な注意</p>
      <p>注意事項はございません。</p>
    </div>
    <div class="terms-text">
      <p>7.前払式支払手段の未使用残高を知ることが出来る方法</p>
      <p>「プリクラON」のサービス内において、チケットの表示（「所持チケット」記載欄）によりご確認いただけます。</p>
    </div>
    <div class="terms-text">
      <p>8.前払式支払手段の利用に関する約款</p>
      <p>本サービスに関する前払式支払手段には、「プリクラON」利用規約が適用されます。</p>
    </div>
    <div class="terms-text">
      <p>9.前払式支払手段におけるお客様の保護に関する措置</p>
      <ul>
        <li>法令上、基準日未使用残高の半額以上の保全が求められており、弊社は半額以上の供託を行っております。</li>
        <li>発行保証金につき、お客様は他の債権者に先立ち弁済を受ける権利を有しております。</li>
        <li>発行保証金は法務局に供託を行っております。</li>
        <li>発行の業務に関し、お客様の意思に反して権限を有しない者の指図が行われたことにより発生したお客様の損失は補償いたしかねます。</li>
      </ul>
    </div>
    <div class="terms-text">
      <p>以上</p>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import { isIOS } from "../assets/js/util"

export default {
  name: "AppSCTransaction",
  components: {
    SectionHeader,
  },
  data () {
    return { isIOS: null }
  },
  mounted() {
    this.isIOS = isIOS();
  },
  methods: {
    oniOS() {
      window.open(process.env.VUE_APP_PRIVACY_POLICY_URL)
    },
    onAndroid() {
      window.open(process.env.VUE_APP_PRIVACY_PROTECTION_URL)
    },
  }
}
</script>

<style scoped>
.terms-text {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
.textLink { color: #DA2240; }
</style>
